<docs>
# FieldGroup
## Назначение
Объединение нескольких полей в группу.
## Особенности
Применяется, когда несколько полей логически связаны (одним описываемым объектом, к примеру) или имеют общий флажок включения.
С помощью свойства position можно перенести подпись группы полей вправо
## Известные проблемы
По стандарту HTML внутри legend можно использовать только текст или заголовки, но нельзя размещать там, к примеру, флажок.
Необходимо переверстать компонент без использования fieldset. В браузере Firefox, возможно и в других, не работает перенос
легенды вправо, необходимо исправить тем же способом, переверстав форму без использования fieldset.
</docs>

<template lang="pug">
  fieldset.group
    legend.legend(:class='{right: position == "right"}')
      slot(name='legend')
    slot(name='fields')
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="sass" scoped>
.group
  border: none
  padding: 5px 0 0 0
  margin: 0 0 15px 0

.legend
  padding: 0 15px
  font-weight: bold
  font-size: 14px

.right
  text-align: right
</style>
